(function () {
  if (window.rpdQuickAddLoader) return;

  var scriptUrl = window.themeScriptUrls && window.themeScriptUrls.quickAdd;
  var productFormScriptUrl = window.themeScriptUrls && window.themeScriptUrls.productForm;
  var styleUrls = (window.themeStyleUrls && window.themeStyleUrls.quickAdd) || [];
  var loadPromise = null;
  var productFormLoadPromise = null;
  var stylePromise = null;

  function quickAddReady() {
    return !!(window.customElements && window.customElements.get('quick-add-modal'));
  }

  function getDeferredQuickAddButton(target) {
    return target && target.closest && target.closest('.quick-add__submit[data-product-url]');
  }

  function findExistingScript() {
    return Array.from(document.querySelectorAll('script[src]')).find(function (script) {
      return script.src === scriptUrl;
    });
  }

  function findExistingProductFormScript() {
    return Array.from(document.querySelectorAll('script[src]')).find(function (script) {
      return script.src === productFormScriptUrl;
    });
  }

  function productFormReady() {
    return !!(window.customElements && window.customElements.get('product-form'));
  }

  function loadProductFormScript() {
    if (productFormReady()) return Promise.resolve();
    if (!productFormScriptUrl) return Promise.resolve();
    if (productFormLoadPromise) return productFormLoadPromise;

    productFormLoadPromise = new Promise(function (resolve, reject) {
      var script = findExistingProductFormScript();

      if (!script) {
        script = document.createElement('script');
        script.src = productFormScriptUrl;
        script.async = true;
        script.defer = true;
        script.dataset.rpdProductFormScript = 'true';
        document.head.appendChild(script);
      }

      function finalize() {
        if (productFormReady()) {
          resolve();
        } else {
          reject(new Error('product-form.js loaded without registering product-form'));
        }
      }

      if (productFormReady()) {
        finalize();
        return;
      }

      script.addEventListener('load', finalize, { once: true });
      script.addEventListener(
        'error',
        function () {
          reject(new Error('Failed to load product-form.js'));
        },
        { once: true }
      );
    }).catch(function (error) {
      productFormLoadPromise = null;
      throw error;
    });

    return productFormLoadPromise;
  }

  function loadQuickAddScript() {
    if (quickAddReady()) return Promise.resolve();
    if (!scriptUrl) return Promise.reject(new Error('Quick add script URL is missing'));
    if (loadPromise) return loadPromise;

    loadPromise = new Promise(function (resolve, reject) {
      var script = findExistingScript();

      if (!script) {
        script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;
        script.defer = true;
        script.dataset.rpdQuickAddScript = 'true';
        document.head.appendChild(script);
      }

      function finalize() {
        if (quickAddReady()) {
          resolve();
        } else {
          reject(new Error('Quick add script loaded without registering quick-add-modal'));
        }
      }

      if (quickAddReady()) {
        finalize();
        return;
      }

      script.addEventListener('load', finalize, { once: true });
      script.addEventListener(
        'error',
        function () {
          reject(new Error('Failed to load quick-add.js'));
        },
        { once: true }
      );
    }).catch(function (error) {
      loadPromise = null;
      throw error;
    });

    return loadPromise;
  }

  function loadQuickAddStyles() {
    if (!styleUrls.length || typeof window.rpdEnsureStyles !== 'function') return Promise.resolve();
    if (stylePromise) return stylePromise;

    stylePromise = window.rpdEnsureStyles(styleUrls).catch(function () {
      stylePromise = null;
    });

    return stylePromise;
  }

  function ensureQuickAddAssets() {
    return loadQuickAddStyles().then(loadProductFormScript).then(loadQuickAddScript);
  }

  function primeQuickAdd(event) {
    if (getDeferredQuickAddButton(event.target)) {
      ensureQuickAddAssets().catch(function () {});
    }
  }

  document.addEventListener('focusin', primeQuickAdd);
  document.addEventListener('mouseover', primeQuickAdd, { passive: true });
  document.addEventListener('touchstart', primeQuickAdd, { capture: true, passive: true });

  document.addEventListener(
    'click',
    function (event) {
      var button = getDeferredQuickAddButton(event.target);
      if (!button || quickAddReady()) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (button.dataset.quickAddBootstrapPending === 'true') return;
      button.dataset.quickAddBootstrapPending = 'true';

      ensureQuickAddAssets()
        .then(function () {
          button.removeAttribute('data-quick-add-bootstrap-pending');
          window.requestAnimationFrame(function () {
            button.click();
          });
        })
        .catch(function () {
          button.removeAttribute('data-quick-add-bootstrap-pending');
          var fallbackUrl = button.getAttribute('data-product-url');
          if (fallbackUrl) window.location.href = fallbackUrl;
        });
    },
    true
  );

  window.rpdQuickAddLoader = {
    ensure: ensureQuickAddAssets,
    isReady: quickAddReady,
  };
  window.rpdLoadQuickAdd = ensureQuickAddAssets;
})();
